import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { DetailInfoTable } from "components/tableSetting/detail";
import { PrimaryBtn } from "components/common/button";
import {
  getTableSettingDetail,
  postTableSetting,
  putTableSetting,
} from "service/api/digital";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { ITableSetting } from "service/interface/digital";
import { OneBtnModal } from "components/common/modal";
import routerConstant from "service/constant/routerConstant";

export function TableSettingDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<ITableSetting>(
    {} as ITableSetting,
  );
  const [isSuccessModalVisible, setIsSuccessModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      if (params.id === "add") {
      } else {
        (async () => {
          const detailRes = await getTableSettingDetail(params.id + "");
          if (detailRes.status === responseCodeConstant.SUCCESS.ok) {
            setDetailData(detailRes.data.data);
          }
        })();
      }
    }
  }, [params]);

  const handleAddBtn = async () => {
    const addRes = await postTableSetting({
      title: detailData.title,
      imgSrc: detailData.imgSrc,
    });
    if (addRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    }
  };

  const handleSaveBtn = async () => {
    const saveRes = await putTableSetting({
      tableSettingId: params.id,
      body: {
        title: detailData.title,
        imgSrc: detailData.imgSrc,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    }
  };

  const handleSuccessModalBtn = () => {
    navigate(routerConstant.TABLESETTING.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessModalVisible}
        title="저장 완료"
        subTitle="저장이 완료되었습니다"
        btnClick={handleSuccessModalBtn}
        btnLabel="확인"
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-gray-4">
              디지털 추모 <span className="text-black">/ 상차림</span>
            </p>
          </div>
          <div className="mt-[32px] flex flex-col rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <DetailInfoTable data={detailData} setData={setDetailData} />
            <div className="mt-[24px] flex justify-end">
              <PrimaryBtn
                isDisabled={!detailData.title || !detailData.imgSrc}
                label={params.id === "add" ? "추가하기" : "저장하기"}
                onClick={params.id === "add" ? handleAddBtn : handleSaveBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
